"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
var _xnfzItem = _interopRequireDefault(require("@/components/xnfzItem.vue"));
var _courseTwo = _interopRequireDefault(require("@/components/courseTwo.vue"));
var _courseItemResource = _interopRequireDefault(require("@/components/courseItemResource.vue"));
var _winCourse = _interopRequireDefault(require("@/components/winCourse.vue"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _characteristiNav = _interopRequireDefault(require("@/components/characteristiNav.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseItem: _courseItem.default,
    XnfzItem: _xnfzItem.default,
    Banner: _banner.default,
    Search: _search.default,
    WinCourse: _winCourse.default,
    courseItemResource: _courseItemResource.default,
    CourseTwo: _courseTwo.default,
    characteristiNav: _characteristiNav.default
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    }
  },
  data: function data() {
    return {
      actNum: 0,
      curType: 0,
      newsItem: [],
      query: {
        isPut: 1,
        pageNum: 1,
        pageSize: 8,
        provinceId: this.$store.getters.provinceId,
        courseName: "",
        majorName: ''
      }
    };
  },
  methods: {
    toSsearch: function toSsearch(e) {
      console.log("dianji", e);
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
    },
    toSecond: function toSecond(url) {
      this.$router.push(url);
    },
    // 专业与课程切换
    tabChange: function tabChange(index) {
      this.actNum = index;
      // alert('111')
    },
    // 搜索
    handleSearch: function handleSearch() {},
    tabs: function tabs(index, id) {
      this.curType = index;
      this.newsItem = [];
      this.findNews(id);
    },
    // 更多
    lookMoreBtn: function lookMoreBtn(v) {
      this.$router.push(v);
    }
  },
  created: function created() {}
};